import React, { useEffect, useState } from "react";
import axios from "axios";
import { baseurl } from "../../../Baseurl";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../api/axiosInstance";

import PageTitle from "../../../Component/Theme/PageTitle"

export default function Category() {
  const [categoryData, setCategoryData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [viewItem, setViewItem] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({ name: "", description: "" });
  const [editId, setEditId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const navigate = useNavigate();

  const getCategory = async () => {
    try {
      const res = await axiosInstance.get(`getAllCategories`);
      setCategoryData(res.data.data || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
      Swal.fire("Error", "Failed to load categories", "error");
    }
  };

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This category will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
    });

    if (confirm.isConfirmed) {
      try {
        await axiosInstance.delete(`deleteCategory/${id}`);
        Swal.fire("Deleted!", "Category has been deleted.", "success");
        getCategory();
      } catch (error) {
        console.error("Delete failed", error);
        Swal.fire("Error", "Something went wrong!", "error");
      }
    }
  };

  const handleAddEdit = async (e) => {
    e.preventDefault();
    try {
      if (editMode) {
        await axiosInstance.put(`updateCategory/${editId}`, formData);
        Swal.fire("Success", "Category updated successfully", "success");
      } else {
        await axiosInstance.post(`/addCategories`, formData);
        Swal.fire("Success", "Category added successfully", "success");
      }
      resetForm();
      getCategory();
    } catch (error) {
      console.error("Submit failed", error);
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };

  const handleEdit = (item) => {
    setFormData({ name: item.name, description: item.description || "" });
    setEditId(item.id);
    setEditMode(true);
    setModalOpen(true);
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const resetForm = () => {
    setFormData({ name: "", description: "" });
    setEditMode(false);
    setEditId(null);
    setModalOpen(false);
  };

  useEffect(() => {
    getCategory();
  }, []);


  const filteredCategories = categoryData.filter((category) =>
    category.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="row">
          <div className="col-12">
            <PageTitle title="Category List" />
            <div className="card table-card">
              <div className="card-header bg-white p-3 d-flex flex-row align-items-center">
                {/* Search Input */}
                <div style={{ position: "relative" }}>
                  <i
                    className="ti ti-search f-16"
                    style={{
                      position: "absolute",
                      left: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      zIndex: 2,
                      color: "#6c757d"
                    }}
                  ></i>
                  <input
                    type="text"
                    placeholder="Search by name..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="form-control m-0"
                    style={{ paddingLeft: "40px", marginBottom: "unset" }}
                  />
                </div>
                <div style={{ flexGrow: 2 }}></div>
                {/* Action Buttons */}
                <div className="d-flex align-items-center gap-2" style={{ margin: "15px" }}>
                  <button className="btn btn-outline-primary btn-sm rounded" onClick={() => setModalOpen(true)}>
                    Add Category
                  </button>
                </div>
              </div>
              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table m-0">
                    <thead>
                      <tr>
                        <th>Sr No.</th>
                        <th>Category Name</th>
                        <th>Description</th>
                        <th className="text-center">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredCategories.length > 0 ? (
                        filteredCategories.map((item, index) => (
                          <tr key={item.id}>
                            <td>{index + 1}</td>
                            <td>{item.name}</td>
                            <td>{item.description || "N/A"}</td>
                            <td style={{ textAlign: "center" }}>
                              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <div
                                  onClick={() => {
                                    setViewItem(item);
                                    setViewModalOpen(true);
                                  }}
                                  style={{ cursor: "pointer" }}
                                  className="avtar avtar-xs  viewIcon"
                                >
                                  <i className="ti ti-eye f-20" />
                                  <span>View</span>
                                </div>
                                <div
                                  onClick={() => handleEdit(item)}
                                  style={{ cursor: "pointer" }}
                                  className="avtar avtar-xs  editIcon"
                                >
                                  <i className="ti ti-edit f-20" />
                                  <span>Edit</span>
                                </div>
                                <div
                                  onClick={() => handleDelete(item.id)}
                                  style={{ cursor: "pointer" }}
                                  className="avtar avtar-xs  deleteIcon"
                                >
                                  <i className="ti ti-trash f-20" />
                                  <span>Delete</span>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="text-center">
                            No categories found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Add/Edit Modal */}
      {modalOpen && (
        <div
          className="modal fade show"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "block",
          }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{editMode ? "Edit Category" : "Add Category"}</h5>

              </div>
              <form onSubmit={handleAddEdit}>

                <div className="modal-body">
                  <div>
                    <label>Name</label>
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      className="form-control"
                    />
                  </div>
                  <div>
                    <label>Description</label>
                    <textarea
                      name="description"
                      value={formData.description}
                      onChange={handleInputChange}
                      required
                      className="form-control"
                    />
                  </div>

                </div>
                <div className="modal-footer">

                  <div>
                    <button
                      type="button"
                      className="cancelText me-2"
                      onClick={resetForm}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="bgBtn">
                      {editMode ? "Update" : "Add"}
                    </button>
                  </div>
                </div>

              </form>
            </div>
          </div>
        </div>
      )}

      {/* View Modal */}
      {viewModalOpen && viewItem && (
        <div
          className="modal fade show"
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "block",
          }}
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Category Details</h5>

              </div>
              <div className="modal-body">

                <label className="form-label">Name</label>
                <input disabled value={viewItem.name} className="form-control" />
                <p>
                  {/* <strong>Description:</strong> {viewItem.description || "N/A"} */}
                  <label className="form-label">Description</label>
                  <textarea disabled value={viewItem.description} className="form-control" />
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="cancelText"
                  onClick={() => {
                    setViewModalOpen(false);
                    setViewItem(null);
                  }}
                >Cancel</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Modal CSS */}
      <style>{`
        .custom-modal {
          position: fixed;
          top: 0; left: 0; right: 0; bottom: 0;
          background-color: rgba(0,0,0,0.4);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 9999;
          overflow-y: auto;
        }
        .modal-content {
          background: #fff;
          border-radius: 8px;
          width: 100%;
          max-width: 500px;
        }
        .avtar {
          display: flex;
          align-items: center;
          gap: 4px;
        }
        .btn-link-secondary {
          color: #3f75c7;
        }
        .btn-link-secondary:hover {
          color: #0056b3;
        }
      `}</style>
    </div>
  );
}
